<template>
  <v-select
      hide-details="auto"
      :items="status"
      v-model="selectStatus"
      item-text="text"
      item-value="value"
      label="Status"
      outlined
      clearable
      dense
      @change="emitInput"
  ></v-select>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      // { text: "Receiving", value: "receiving" },
      { text: "Pending", value: "pending" },
       { text: "Partially Paid", value: "partially_paid" },
      { text: "Paid", value: "paid" },
       { text: "Reserved", value: "reserved" },
      { text: "Cancelled", value: "cancelled" },
      //  { text: "Suspended", value: "suspended" },
    ],
    selectStatus: null,
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectStatus);
    }
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    }
  },
  created(){
  }
};
</script>